<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container class="px-10 pt-8">
        <p class="subtitle-1 font-weight-bold mb-2">Update Paid Payment</p>
        <v-row>
          <v-col class="py-0" cols="12" sm="12" md="3">
            <p class="caption">Tenant:</p>
          </v-col>
          <v-col class="py-0" cols="12" sm="12" md="9">
            <p class="caption font-weight-bold">{{ paidPayment.tenantName }}</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0" cols="12" sm="12" md="3">
            <p class="caption">Unit:</p>
          </v-col>
          <v-col class="py-0" cols="12" sm="12" md="9">
            <p class="caption font-weight-bold">{{ paidPayment.unitName }}</p>
          </v-col>
        </v-row>
        <v-divider class="my-4"></v-divider>
        <v-form v-model="isFormValid">
          <v-row>
            <v-col class="py-1" cols="12" sm="12" md="6">
              <v-currency-field
                v-model="paidPayment.amount"
                type="number"
                label="Amount To Pay"
                prepend-inner-icon="mdi-cash"
                disabled
                outlined
                dense
                hide-details
              >
              </v-currency-field>
            </v-col>
            <v-col class="py-1" cols="12" sm="12" md="6">
              <v-currency-field
                v-model="paidPayment.amount"
                type="number"
                label="Amount Paid"
                prepend-inner-icon="mdi-cash"
                disabled
                outlined
                dense
                hide-details
              >
              </v-currency-field>
            </v-col>
          </v-row>

          <v-row v-if="paidPayment.secDepUsed && paidPayment.secDepUsed.length">
            <v-col class="py-1" cols="12" sm="12" md="12">
              <p class="caption font-weight-bold">Used Security Deposit:</p>
              <v-list-item
                v-for="securityDeposit in paidPayment.secDepUsed"
                :key="`update_paid_payment_security_deposit_${securityDeposit.securityDepositId}`"
              >
                <v-list-item-avatar size="30">
                  <v-icon class="grey lighten-1" small dark> mdi-cash </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="body-2">
                    Amount:
                    {{
                      formatCurrency(securityDeposit.amount)
                    }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>

          <v-row v-if="paidPayment.balanceUsed">
            <v-col class="py-1" cols="12" sm="12" md="12">
              <p class="caption font-weight-bold">Used Credits:</p>
              <v-list-item v-if="paidPayment.balanceUsed">
                <v-list-item-avatar size="30">
                  <v-icon class="grey lighten-1" small dark> mdi-cash </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="body-2">
                    Amount:
                    {{
                      formatCurrency(paidPayment.balanceUsed)
                    }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="py-1" cols="12" sm="12" md="12">
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    label="Date Paid"
                    prepend-inner-icon="mdi-calendar-month"
                    v-bind="attrs"
                    readonly
                    outlined
                    dense
                    hide-details
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  no-title
                  scrollable
                  @input="dateMenu = false"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1" cols="12" sm="12" md="12">
              <v-textarea
                v-model="description"
                label="(Optional) Add a description"
                hide-details
                dense
                outlined
                class="my-1"
                rows="3"
              >
              </v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="12">
              <v-file-input
                v-model="attachments"
                accept="image/*, application/pdf"
                label="Upload Attachments"
                prepend-icon=""
                chips
                small-chips
                multiple
                outlined
                dense
                hide-details
              >
                <template v-slot:prepend-inner>
                  <v-icon small class="mt-1">mdi-paperclip</v-icon>
                </template>
              </v-file-input>
            </v-col>
          </v-row>
          <p
            v-if="currentAttachments.length"
            class="caption font-weight-bold mt-2"
          >
            Attachments
          </p>
          <v-chip-group column multiple>
            <v-chip
              v-for="(item, index) in currentAttachments"
              :key="index"
              close
              @click:close="removeAttachment(item, index)"
            >
              {{ truncate(item.filename) }}
            </v-chip>
          </v-chip-group>
          <!-- <v-row>
            <v-col class="pb-2" cols="12" sm="12" md="12">
              <v-checkbox v-model="confirmSendEmail" class="my-0" hide-details>
                <template v-slot:label> Send email to tenant </template>
              </v-checkbox>
            </v-col>
          </v-row> -->
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="font-weight-bold"
            color="primary darken-1"
            text
            :disabled="!isFormValid"
            @click="finish"
            >Finish</v-btn
          >
          <v-btn
            class="font-weight-bold"
            color="grey darken-1"
            text
            @click="cancel"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-container>
    </v-card>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { DATEPICKER, dayjs } from '../../util/date'
import { formatCurrency } from '../../util/currency'

export default {
  data() {
    return {
      paidPayment: {},
      tenantId: -1,
      bedId: -1,
      bedName: '',
      dialog: false,
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      date: '',
      datePicker: '',
      dateMenu: false,
      description: '',
      currentAttachments: [],
      attachments: [],
      loading: true,
      confirmSendEmail: false,
      isFormValid: false,
      formatCurrency
    }
  },
  computed: {
    access() {
      return this.$root.$roleAccess('payment').access
    }
  },
  methods: {
    async open(paidPayment) {
      this.dialog = true
      this.paidPayment = paidPayment
      this.description = paidPayment.description
      this.date = dayjs(paidPayment.date).format(DATEPICKER)
      this.currentAttachments = paidPayment.attachments
      this.loading = false
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async finish() {
      try {
        this.loading = true
        await this.$store.dispatch('payments/updatePaidPayment', {
          paidPaymentId: this.paidPayment.paidPaymentId,
          description: this.description,
          date: dayjs(this.date).format(),
          attachments: this.attachments.filter(
            (attachment) => attachment instanceof File
          ),
          currentAttachments: this.currentAttachments
        })

        this.dialog = false
        this.loading = false

        this.$root
          .$confirm({
            title: 'Update Paid Payment',
            message: `The paid payment has been updated.`,
            reconfirmOnly: true,
            confirmText: 'OK',
            options: {
              color: 'success'
            }
          })
          .then(() => {
            this.resolve(true)
          })
      } catch (err) {
        this.loading = false
        this.$root.$confirm({
          title: 'Update Paid Payment',
          message: err,
          options: {
            color: 'error'
          },
          reconfirmOnly: true,
          confirmText: 'OK'
        })
      }
    },
    cancel() {
      this.dialog = false
      this.loading = false
    },
    async removeAttachment(item, index) {
      if (
        await this.$root.$confirm({
          title: 'Remove attachment',
          message: `Are you sure you would like to delete ${item.filename}?`
        })
      ) {
        this.currentAttachments.splice(index, 1)
      }
    },
    truncate(input) {
      if (input.length > 7) {
        return input.substring(0, 7) + '...'
      }
      return input
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 0;
}
</style>
